<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Edit Webhook'"
      [canGoBack]="true"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

      @if (loaded) {
        <tidy-card>
          <tidy-row class="field-bottom-padding field-top-padding">
            <tidy-input
              formControlName="webhookUrl"
              [form]="form.controls.webhookUrl"
              [label]="'Endpoint URL'"
              [icon]="'assets/svg/globe.svg'"
              [errorMessage]="'Please input a URL'"
              [submitted]="submitted" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              formControlName="description"
              [form]="form.controls.description"
              [label]="'Description'"
              [icon]="'assets/svg/information-circle.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'Webhook channel:'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-radio-button
              formControlName="channel"
              [form]="form.controls.channel"
              [items]="channelItems" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'Events to listen to:'" />
          </tidy-row>
          @for (event of eventItems; track event) {
            <tidy-checkbox
              [(checked)]="event.checked"
              [initValue]="event.checked"
              [items]="[{value: event.value, viewValue: event.viewValue}]" />
          }
          @if (showSelectedEventsError) {
            <tidy-error-message
              [text]="'Please select events to listen to.'" />
          }
        </tidy-card>
        <tidy-error-message
          [text]="errorMessage" />
        <tidy-button
          [text]="'Save Changes'"
          [action]="boundSaveChanges"
          class="primary" />
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
